import { Address, PublicClient } from 'viem';

import { getMainTokenContract } from 'modules/api/contracts/getMainTokenContract';
import { memoizePromise } from 'modules/api/methods/memoizePromise';

async function _getPoolAddresses(client: PublicClient): Promise<Address[]> {
  const MATTokenContract = getMainTokenContract(client);

  const poolsCount = Number(await MATTokenContract.read.getPoolsCount());

  if (poolsCount > 0) {
    const pools = await Promise.all(
      Array.from({ length: poolsCount }, (_, i) =>
        MATTokenContract.read._pools([BigInt(i)]),
      ),
    );

    return pools.filter(
      pool => typeof pool === 'string',
    ) as unknown[] as Address[];
  }

  return [];
}

export const getPoolAddresses = memoizePromise(_getPoolAddresses, client => {
  return `${client?.chain?.id || 'unknown'}`;
});
